import URLSearchParams from '@ungap/url-search-params' // polyfill

const authTokenKey = 'alpha-auth-token'

export function setAuthToken (token: string) {
  localStorage.setItem(authTokenKey, token)
}

export function getAuthToken (): string | undefined {
  // Populate localstorage auth token from URL if it exists, used for finishing the SSO flow
  const urlParams = new URLSearchParams(window.location.search)
  const urlTokenKey = 'setToken'
  if (urlParams.has(urlTokenKey)) {
    const token = urlParams.get(urlTokenKey) as string

    // Replace the url with one without the token
    urlParams.delete(urlTokenKey)
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`
    window.history.replaceState(null, document.title, newUrl)

    setAuthToken(token)
  }
  return localStorage.getItem(authTokenKey) || undefined
}

export function removeAuthToken () {
  localStorage.removeItem(authTokenKey)
}
